import React, { Component } from 'react'
import styles from './WebApp.styl'
import { Redirect } from 'react-router-dom'
import { renderRoutes, matchRoutes } from 'react-router-config'
import TranslationContext from '../utils/TranslationContext'
import Helmet from 'react-helmet'
import { Footer, SessionMenu } from './components'
import { object, func, any } from 'prop-types'
import AppIcons from './components/Icons/app-icons'
import { connect } from 'react-redux'

class WebApp extends Component {

	static propTypes = {
		route: object,
		location: object,
		match: object,
		dispatch: func,
		session: any,
		fetchAction: any
	}
	render() {
		const { route, dispatch, session, fetchAction, match: { params } } = this.props
		if (!session.id) { return <Redirect to="/login" /> }
		if (!session.isActive) { return <Redirect to="/account_verification" /> }
		return (
			<div className={ styles['App'] }>
				<AppIcons />
				<SessionMenu session={ session } />
				{ renderRoutes(route.routes, { dispatch, fetchAction }) }
				<Footer />
			</div>
		)
	}
}

const mapStateToProps = state => ({
	session: state.session
})

export default connect(mapStateToProps)(WebApp)



// WEBPACK FOOTER //
// ./src/client/webapp/WebApp.js